import { useState } from 'react'

// Create your forceUpdate hook
export function useForceUpdate() {
    let [value, setState] = useState(true)
    return () => setState(!value)
}
